export default "__VITE_ASSET__Ba_0gnfb__"